import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  AfterViewInit,
  viewChild,
} from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { SidenavService } from '../services/sidenav.service';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-deal-list',
    templateUrl: './deal-list.component.html',
    styleUrls: ['./deal-list.component.scss'],
    standalone: true,
    imports: [MatSidenavModule, SidenavComponent, RouterOutlet]
})
export class DealListComponent implements OnDestroy, AfterViewInit {
  readonly sidenav = viewChild.required<MatSidenav>('sideNav');
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: (e: MediaQueryListEvent) => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private sidenavService: SidenavService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('change', this._mobileQueryListener);
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener('change', this._mobileQueryListener);
  }

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav());
  }
}
